import React, { useRef, useState, useEffect } from 'react';
import ToolbarItems from './svgPanZoomToolbarItems';
import { ReactSvgPanZoomLoader } from 'react-svg-pan-zoom-loader';
import { createUseStyles } from 'react-jss';

import CustomSvgPanZoom from 'src/utils/CustomSvgPanZoom';

const useStyles = createUseStyles({
	SvgPanZoom: {
		position: 'relative',
		right: '1px',
		'@global g': {
			pointerEvents: 'none',
		},
	},
});

const SvgPanZoom = (props) => {
	const Viewer = useRef(null);
	const { src, refBigWidth, refBigHeight, imgWidth, imgHeight } = props;
	const classes = useStyles();

	useEffect(() => {
		Viewer.current.fitToViewer('center', 'center');
	}, []);

	return (
		<ReactSvgPanZoomLoader
			src={src}
			render={(content) => (
				<CustomSvgPanZoom
					reference={Viewer}
					content={content}
					width={refBigWidth}
					height={refBigHeight}
					svgWidth={imgWidth}
					svgHeight={imgHeight}
					compClass={classes.SvgPanZoom}
					toolbarProps={{ SVGAlignX: 'center', SVGAlignY: 'center' }}
					CustomToolbarItems={ToolbarItems}
				/>
			)}
		/>
	);
};

export default SvgPanZoom;
